import { DimensionUsage } from './metrics';

export const AutoUpdate = {
  Off: 'off',
  Streaming: 'streaming',
  Periodic: 'periodic'
};

export const MetricsExplorerIntegratedMode = DimensionUsage;

// Today, we can get away with just returning integrated mode directly since it happens to be === to dimension usage.
// If in the future we change MetricsExplorerIntegratedMode to drift from DimensionUsage, we will need to do some translation of inteagrated mode -> dimension usage
export const integratedModeToDimensionUsage = (integratedMode) => integratedMode || DimensionUsage.Query;
